var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 263,
    viewBox: "0 0 246 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 245,
    height: 262,
    rx: 19.5,
    fill: "#F4F4F4",
    stroke: "#DFDFDF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_425_2203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151 82V93.96C151 93.96 143.04 94 143 93.96V82H131C131 82 131.04 74.04 131 74H143V62H151V74H163V82H151ZM139 98V86H127V74H95C90.6 74 87 77.6 87 82V130C87 134.4 90.6 138 95 138H143C147.4 138 151 134.4 151 130V98H139ZM95 130L107 114L115 126L127 110L143 130H95Z",
    fill: "#AAAAAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_425_2203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(75 54)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.bae3bb2cf8740c073e4a99989e324dd1.svg";
export { ForwardRef as ReactComponent };